import React from 'react';
import cn from 'classnames';

import styles from './PasswordRules.module.scss';
import {useTranslation} from 'react-i18next';
import Tick from 'components/common/icons/redesign/Tick';
import useTooltip from 'hooks/common/useTooltip';
import classNames from 'classnames';

const PasswordRules = ({passwordValidation, values, wrapperClassName}) => {
    const {t} = useTranslation();

    const {tooltip, hoverFunctions} = useTooltip('Example: %$#@*&()<>/?', styles.tooltip);

    return (
        <div
            className={classNames(styles.wrapper, {
                [wrapperClassName]: wrapperClassName,
            })}
        >
            <div className={styles.title}>{t('auth:text.passwordMustContain')}:</div>
            <div className={styles.grid}>
                {Object.keys(passwordValidation).map(key => {
                    const isSpecialSymbol = key === 'special';
                    const hover = isSpecialSymbol ? {...hoverFunctions} : null;
                    return (
                        <div className={styles.item} key={key} {...hover}>
                            <Tick
                                className={cn(styles.tick, {
                                    [styles.active]: passwordValidation[key],
                                    [styles.danger]: !passwordValidation[key] && !!values.password,
                                })}
                            />
                            <span>{t(`auth:text.${key}`)}</span>
                            {isSpecialSymbol && tooltip}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PasswordRules;
